import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=ac71322c&scoped=true&"
import script from "./FileDisplay.vue?vue&type=script&lang=ts&"
export * from "./FileDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=ac71322c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac71322c",
  null
  
)

export default component.exports